import { IsString, Length, Matches } from 'class-validator';

import { passwordRegexp } from '@onArte/shared/regexp';

export class ChangePasswordModel {
  @IsString()
  public hash: string;

  @Length(8, 64)
  @Matches(passwordRegexp)
  public newPassword: string;
}
